//hook
import { useState, useEffect,} from 'react';

//component
import BestCar from '../../component/bestCar/BestCar';
import PopularCar from '../../component/popularCar/PopularCar';

//api
import { GetBestCars } from '../../api/Cars/GetBestCars';
import { GetPopularCars } from '../../api/Cars/GetPopularCars';
import { useApi } from '../../hooks/useApi';

//type
import { carType } from '../../api/Cars/type/CarsType';

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../../translate/i18n';

//popup
import CarDetails from '../../popup/bestCarDetails/CarDetails';

//image
import heroSign from "../../assets/home/hero-sign.png"
import heroCar from "../../assets/home/hero-car.png"
import availability from "../../assets/home/availability.png"
import comfort from "../../assets/home/comfort.png"
import savings from "../../assets/home/savings.png"
import mercedesBenz from "../../assets/home/mercedes-benz.png"

//mui
import { Button, CardActionArea } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';


//mui icon
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import ReplayIcon from '@mui/icons-material/Replay';


//swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

//css file
import styles from "./Home.module.css"
import { error } from 'console';

const Home = () =>{
  const { t } = useTranslation();
  const [bestCarsData, setBestCarsData] = useState<carType[]>([]);
  const {
    loading: bestCarLoading,
    error: bestCarError,
    HandlerApi: getBestCars
  } = useApi(GetBestCars, "GET");
  const [popularCarsData, setPopularCarsData] = useState<carType[]>([]);
  const {
    loading: popularCarLoading,
    error: popularCarError,
    HandlerApi: getPopularCars
  } = useApi(GetPopularCars, "GET");

  
  const [selectedCar, setSelectedCar] = useState<carType | null>(null);
  const [openBestCarDetails, setOpenBestCarDetails] = useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      const resultBestCars = await getBestCars();
      setBestCarsData(resultBestCars.data);
      const resultPopularCars = await getPopularCars();
      setPopularCarsData(resultPopularCars.data);
    };

    fetchData();
  }, []);

  return (
    <div className="mt-5">
      {/* section1 */}
      <div className="
      py-10
      bg-customerColor 
      rounded-[40px] 
      px-10
      relative
      z-[1]
      overflow-hidden
      max-sm:hidden
      "
      >
        <div className='flex md:flex-row sm:flex-col items-center justify-center h-full'>
          <div className='md:w-1/2 max-md:w-full max-md:text-center'>
            <h1 
            style={{ whiteSpace: "pre-line" }} 
            className='mb-3 text-white text-5xl max-sm:text-4xl'
            >
              {t("hero_title_home")}
            </h1>
            <p 
            style={{ whiteSpace: "pre-line" }}
            className='text-white'
            >
              {t("hero_desc_home")}
            </p>
            <Button className='!bg-darkColor !mt-5 !text-white !capitalize'>
              {t("view_all_cars")}
            </Button>
          </div>
          <div className='md:w-1/2 max-md:w-[400px]'>
            <img className={`${i18n.language === "en" ? "": "scale-x-[-1]"}`} src={heroCar} alt='no-photo'/>
          </div>
        </div>
        <img 
        className={`${i18n.language === "en" ? "": "scale-x-[-1]"} w-full h-full absolute top-0 left-0 z-[-1]`}
        src={heroSign} 
        alt='no-photo'
        />
      </div>
      {/* section2 */}
      <div className='grid grid-cols-3 grid-rows-1 gap-3 mt-5'>
        <div className='flex flex-col gap-3 text-center'>
          <img className='m-auto' src={availability} alt='no-photo'/>
          <h3 className='font-[800]'>{t("availability")}</h3>
          <p className='flex-1 max-sm:text-xs'>{t("availability_info")}</p>
        </div>
        <div className='flex flex-col gap-3 text-center'>
          <img className='m-auto' src={comfort} alt='no-photo'/>
          <h3 className='font-[800]'>{t("comfort")}</h3>
          <p className='flex-1 max-sm:text-xs'>{t("comfort_info")}</p>
        </div>
        <div className='flex flex-col gap-3 text-center'>
          <img className='m-auto' src={savings} alt='no-photo'/>
          <h3 className='font-[800]'>{t("savings")}</h3>
          <p className='flex-1 max-sm:text-xs'>{t("savings_info")}</p>
        </div>
      </div>
      {/* section3 */}
      <div className='mt-20 max-sm:mt-10 flex max-sm:flex-col justify-between items-center'>
        <div className="flex items-center justify-center 
        lg:w-[350px] lg:h-[350px] md:w-[300px] md:h-[300px] sm:w-[250px] sm:h-[250px] max-sm:w-[200px] max-sm:h-[200px]
        rounded-full"
        style={{ background: 'conic-gradient(#34A835 0deg 180deg, #373737 180deg 360deg)'}}
        >
          <img className={i18n.language === "en" ? "": "scale-x-[-1]"} src={mercedesBenz} alt='no-photo'/>
        </div>
        <div className='w-1/2 max-sm:w-full max-sm:mt-5'>
          <h1 className='text-darkColor font-[800] text-3xl max-sm:text-xl mb-2'>{t("our_services")}</h1>
          <div className='mb-5'>
            <h4 className='font-[800] mb-2'>{t("car_hire")}</h4>
            <p>{t("car_hire_info")}</p>
          </div>
          <div className='mb-5'>
            <h4 className='font-[800] mb-2'>{t("car_sales")}</h4>
            <p>{t("car_sales_info")}</p>
          </div>
          <div className='mb-5'>
            <h4 className='font-[800] mb-2'>{t("hire_driver")}</h4>
            <p>{t("hire_driver_info")}</p>
          </div>
        </div>
      </div>
      {/* section4 */}
      <div className='mt-20'>
        <div className='flex justify-between'>
          <h1 className='text-darkColor font-[800] text-3xl max-sm:text-xl max-sm:mb-2'>{t("best_cars")}</h1>
          <div className='flex gap-2'>
            <p className='max-sm:text-sm'>{t("view_all")}</p>
            {i18n.language === "en" ? <ArrowForwardIcon/> : <ArrowBackOutlinedIcon/>}
          </div>
        </div>
        <div className='mt-5'>
          {bestCarLoading
          ? 
          <div className='flex justify-center'>
            <CircularProgress/>
          </div>
          :
          <div>
            {bestCarError
            ?
              <div className='cursor-pointer flex justify-center'>
              <ReplayIcon 
              onClick={getBestCars}
                // onClick={async () => {
                //   // إعادة تعيين البيانات القديمة (اختياري)
                //   setBestCarsData([]);
                //   await getBestCars();  // سيعيد ضبط loading و error تلقائيًا
                // }} 
                className='!text-[40px]' 
              />
              </div>
            :
              <div>
                <CardActionArea>
                  <Swiper
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    300: { slidesPerView: 1.5 },
                    640: { slidesPerView: 3.5 },
                  }}
                  key={i18n.language}
                  dir={i18n.language === "ar" ? "rtl" : "ltr"}
                  spaceBetween={20}
                  grabCursor={true}
                  navigation
                  pagination={{ clickable: true }}
                  modules={[Navigation, Pagination]}
                  className={`carCardSwiper ${styles.carCardSwiper}`}
                  >
                    {
                      bestCarsData.length !== 0
                      ? 
                      <>
                      {bestCarsData.map((element, index) => (
                      <SwiperSlide 
                      key={index}
                      >
                      <div className='cursor-pointer'
                      key={index}
                      >
                        <BestCar element={element}/>
                      </div>
                      </SwiperSlide>
                    ))}
                      </>
                      :<p className='flex justify-center items-center'>{t("no_cars")}</p>
                    }
                  </Swiper>
                </CardActionArea>
                {selectedCar && (
                  <CarDetails
                    selectedCar={selectedCar}
                    setSelectedCar={setSelectedCar}
                    openBestCarDetails={openBestCarDetails}
                    setOpenBestCarDetails={setOpenBestCarDetails}
                  />
                )}   
              </div>
            }
          </div>
          }
        </div>
      </div>
      {/* section5 */}
      <div className='mt-20'>
        <div className='flex justify-between'>
          <h1 className='text-darkColor font-[800] text-3xl max-sm:text-xl max-sm:mb-2'>{t("popular_cars")}</h1>
          <div className='flex gap-2'>
            <p className='max-sm:text-sm'>{t("view_all")}</p>
            {i18n.language === "en" ? <ArrowForwardIcon/> : <ArrowBackOutlinedIcon/>}
          </div>
        </div>
        <div className='mt-5'>
          {popularCarLoading
          ? 
          <div className='flex justify-center'>
            <CircularProgress/>
          </div>
          :
          <div>
            {popularCarError
            ?
              <div className='cursor-pointer flex justify-center'>
                <ReplayIcon onClick={getPopularCars} className='!text-[40px]'/>
              </div>
            :
              <div>
                <CardActionArea>
                  <Swiper
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    300: { slidesPerView: 1.5 },
                    640: { slidesPerView: 3.5 },
                  }}
                  key={i18n.language}
                  dir={i18n.language === "ar" ? "rtl" : "ltr"}
                  spaceBetween={20}
                  grabCursor={true}
                  navigation
                  pagination={{ clickable: true }}
                  modules={[Navigation, Pagination]}
                  className={`carCardSwiper ${styles.carCardSwiper}`}
                  >
                    {popularCarsData.map((element, index) => (
                      <SwiperSlide 
                      key={index}
                      >
                        <PopularCar element={element}/>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </CardActionArea>
                {selectedCar && (
                  <CarDetails
                    selectedCar={selectedCar}
                    setSelectedCar={setSelectedCar}
                    openBestCarDetails={openBestCarDetails}
                    setOpenBestCarDetails={setOpenBestCarDetails}
                  />
                )}  
              </div>
            }
          </div>
          }
        </div>
      </div>
    </div>
  )
}

export default Home
